<mat-card class="overview-card total-table-border">
	<mat-card-header class="overview-card-header">
		<h6 class="text-center font-weight-bold my-xs">
			<button
				mat-list-avatar
				type="button"
				class="mx-1"
				[style.background]="payCategory.colorName"
				mat-icon-button
			>
				<i class="fa-1-5x fa {{ payCategory.iconName }}"></i>
			</button>
			{{ payCategory.name }} -
			<span class="readonly-label">{{ payCategory.shortCode }}</span>
		</h6>
	</mat-card-header>
	<mat-card-content class="card-content no-padding pa-1">
		<div fxFlex="33.33%" class="vertical-align">
			<mat-list>
				<mat-list-item *ngIf="payCategory.isAvailability">
					<p mat-line class="readonly-label no-margin-tb">
						<i class="fa fa-check success" aria-hidden="true"></i>
						Availability
					</p>
				</mat-list-item>
				<mat-list-item *ngIf="payCategory.isInstructionGiven">
					<p mat-line class="readonly-label no-margin-tb">
						<i class="fa fa-check success" aria-hidden="true"></i>
						Instruction Given
					</p>
				</mat-list-item>
				<mat-list-item *ngIf="payCategory.isFlatRateInstruction">
					<p mat-line class="readonly-label no-margin-tb">
						<i class="fa fa-check success" aria-hidden="true"></i>
						Flat Rate Instruction
					</p>
				</mat-list-item>
				<mat-list-item *ngIf="payCategory.isIncentive">
					<p mat-line class="readonly-label no-margin-tb">
						<i class="fa fa-check success" aria-hidden="true"></i>
						Incentive
					</p>
				</mat-list-item>
				<mat-list-item *ngIf="payCategory.isApHours">
					<p mat-line class="readonly-label no-margin-tb">
						<i class="fa fa-check success" aria-hidden="true"></i>
						A&P Hours
					</p>
				</mat-list-item>
				<mat-list-item *ngIf="payCategory.isFlightTime">
					<p mat-line class="readonly-label no-margin-tb">
						<i class="fa fa-check success" aria-hidden="true"></i>
						Flight Time
					</p>
				</mat-list-item>
				<mat-list-item *ngIf="payCategory.isVisibleToLoadSpecialists">
					<p mat-line class="readonly-label no-margin">
						<i class="fa fa-check success" aria-hidden="true"></i>
						Visible to Load Specialists
					</p>
				</mat-list-item>
			</mat-list>
		</div>
		<div fxFlex="33.33%" class="text-center">
			<h5 mat-line class="ma-0">{{ payCategory.unit }}</h5>
			<p mat-line class="readonly-label no-margin-tb">Unit</p>
		</div>
		<div
			fxFlex="33.33%"
			class="text-center"
			[ngClass]="!payCategory.exportToWorkday && !payCategory.factorAmount ? 'vertical-align' : ''"
		>
			<p *ngIf="!payCategory.exportToWorkday" mat-line class="readonly-label no-margin">
				<i class="fa fa-times warning" aria-hidden="true"></i>
				Not exported to workday
			</p>
			<h5
				mat-line
				class="ma-0"
				*ngIf="payCategory.workdayPayCode || (!payCategory.exportToWorkday && payCategory.factorAmount != 0)"
			>
				{{ payCategory.factorAmount }}%
			</h5>
			<p mat-line class="readonly-label no-margin-tb">{{ payCategory.workdayPayCode }}</p>
		</div>
	</mat-card-content>
	<mat-card-actions class="card-action-box">
		<button
			[id]="idPrefix + '_EDIT'"
			type="button"
			color="primary"
			mat-button
			(click)="
				navigate(
					'' + payCategory.payCategoryId,
					onlyArchived ? 'archived' : 'active',
					payCategory.effectiveStart
				)
			"
		>
			<span *ngIf="!onlyArchived">Edit</span>
			<span *ngIf="onlyArchived">View</span>
		</button>
		<div fxFlex></div>
		<span
			[id]="idPrefix + '_SCHEDULE_DESCRIPTION'"
			*ngIf="!onlyArchived && isPayCategoryArchived && payCategory.effectiveEnd"
		>
			<mat-error>Scheduled deletion effective on {{ payCategory.effectiveEnd | date: 'MMMM-yyyy' }}</mat-error>
		</span>
		<span
			[id]="idPrefix + '_SCHEDULE_DESCRIPTION'"
			*ngIf="
				!onlyArchived &&
				!isPayCategoryArchived &&
				!payCategory.isFuture &&
				payCategory.scheduledChanges &&
				payCategory.scheduledChanges.length &&
				payCategory.scheduledChanges[0].effectiveDate
			"
		>
			Scheduled changes effective on {{ payCategory.scheduledChanges[0].effectiveDate | date: 'MMMM-yyyy' }}
		</span>
		<span
			[id]="idPrefix + '_SCHEDULE_DESCRIPTION'"
			*ngIf="!onlyArchived && payCategory.isFuture && payCategory.effectiveStart"
			>New Category effective on {{ payCategory.effectiveStart | date: 'MMMM-yyyy' }}</span
		>
		<span [id]="idPrefix + '_SCHEDULE_DESCRIPTION'" *ngIf="onlyArchived"
			>Category Archived on {{ payCategory.effectiveEnd | date: 'MMMM-yyyy' }}
		</span>
	</mat-card-actions>
</mat-card>
